import StockView from '../StockView.vue'

export const stockRoute = [
  {
    path: '/stock/',
    name: 'stock',
    component: StockView,
    meta: {
      key: 'view_est'
    }
  }
]
